import { Injectable } from '@angular/core';

const ACCESS_TOKEN_KEY = 'accessToken';

/**
 * The single place that touches localStorage for the session token.
 *
 * Everything that used to read `localStorage.getItem('accessToken')` inline — AuthService,
 * UserService, the navigation data and eight feature components — goes through here instead,
 * so a test can supply a token by providing a stub rather than by writing to the real
 * browser storage and remembering to clear it again.
 */
@Injectable({providedIn: 'root'})
export class TokenStorage
{
    get token(): string
    {
        return localStorage.getItem(ACCESS_TOKEN_KEY) ?? '';
    }

    set token(value: string)
    {
        localStorage.setItem(ACCESS_TOKEN_KEY, value);
    }

    clear(): void
    {
        localStorage.removeItem(ACCESS_TOKEN_KEY);
    }
}
